import { useState } from "react";
import { Syringe, Sparkles } from "lucide-react";
import VaccinationCard from "./VaccinationCard";
import VaccinesPanel from "./VaccinesPanel";

// Fusiona Cartilla + Recomendaciones IA en una sola pestaña con dos vistas.
export default function VaccinesTab({ patient }) {
  const [view, setView] = useState("cartilla");
  const TABS = [
    { k: "cartilla", l: "Cartilla", icon: Syringe },
    { k: "recomendaciones", l: "Recomendaciones IA", icon: Sparkles },
  ];
  return (
    <div className="space-y-5">
      <div className="flex bg-muted rounded-full p-1 w-fit" data-testid="vaccines-view-toggle">
        {TABS.map((t) => (
          <button key={t.k} data-testid={`vaccines-view-${t.k}`} onClick={() => setView(t.k)}
            className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-bold transition-all ${view === t.k ? "bg-brand-terracotta text-white" : "text-brand-ink/60"}`}>
            <t.icon size={15} /> {t.l}
          </button>
        ))}
      </div>
      {view === "cartilla" ? <VaccinationCard patient={patient} /> : <VaccinesPanel patient={patient} />}
    </div>
  );
}
